<template>
    <div class="flex-col">
        <vnavbar title="清点单列表" class="backbar" left-text="返回" left-arrow @click-left="back" />
        <div class="header">
            <div class="patient">
                <div class="name">{{surgeryInfo.patient_name}}</div>
                <div class="bed">{{surgeryInfo.sex||'--'}}/{{surgeryInfo.age||'--'}}/{{surgeryInfo.bed_no||'--'}}</div>
            </div>
            <div>
                <div class="more">
                    <div class="moredevice">{{surgeryInfo.surgeries}}</div>
                    <div @click="isShowMore=!isShowMore">查看更多<span><i
                                :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span></div>
                </div>
                <div v-if="isShowMore" class="surgery">
                    <div>台次:{{surgeryInfo.scheduled_sequence}}</div>
                    <div>手术间:{{surgeryInfo.dic_operating_room}}</div>
                    <div>科室:{{surgeryInfo.dic_section}}</div>
                    <div>术前诊断:{{surgeryInfo.plan_diseases}}</div>
                    <div>手术医生:{{surgeryInfo.surgeon}}</div>
                    <div class="time">手术计划开始时间:{{surgeryInfo.plan_time && this.$moment(surgeryInfo.plan_time).format(`YYYY-MM-DD
                        HH:mm:ss`)}}</div>
                </div>
            </div>
        </div>
        <div v-if="countingList && countingList.length>0" class="scrollContent">
            <vpullrefresh v-model="refreshing" @refresh="onRefresh">
                <vlist v-model="loading" :finished="finished" finished-text="" @load="onLoad">
                    <div class="content flex-col" v-if="countingList && countingList.length>0" :style="{'height':`${ this.screenHeight - 200}px`}">
                        <div style="padding:10px;border-bottom: 1px dashed #04A891;" v-for="(countingitem, index) in countingList"
                            @click="gotoCountingItem(countingitem)" :key="index">
                            【{{countingitem.count_type}}】{{countingitem.workflow_name}}
                        </div>
                    </div>
                    <div v-else>
                        <vempty description="暂无数据" class="empty" />
                    </div>
                </vlist>
            </vpullrefresh>
        </div>
        <div class="bottom">
            <vbutton class="btnTrans" icon="edit" type="info" @click="createCountingFlow"></vbutton>
            <vbutton class="btnTrans" icon="printer" type="info" @click="printFlow"></vbutton>
        </div>
    </div>
</template>

<script>
import { NavBar as vnavbar, Empty, PullRefresh as vpullrefresh, List as vlist, Radio as vradio, RadioGroup as vradiogroup, Cell as vCell, Button as vbutton, Dialog, Field as vfield, Tabbar as vtabbar, TabbarItem as vtabbaritem, Icon as vicon, Tag as vtag } from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
    name: `CountingList`,
    components: { vpullrefresh, vlist, vnavbar, Empty, vtabbar, vtabbaritem, vradio, vradiogroup, vCell, vbutton, [Dialog.Component.name]: Dialog.Component, vfield, vicon, vtag },
    data() {
        let sessionSurgeryObj = sessionStorage.getItem(`surgeryInfo`)
        let sessionSurgeryInfo = sessionSurgeryObj && JSON.parse(sessionSurgeryObj) || null
        let sessionPrevPath = sessionStorage.getItem(`prevPath`)
        return {
            surgeryId: this.$route.query.surgeryId && parseInt(this.$route.query.surgeryId) || 0,
            surgeryInfo: this.$route.params.surgeryInfo || sessionSurgeryInfo,
            prevPath: this.$route.params.prevPath || sessionPrevPath,
            isShowMore: false,
            loading: false,
            finished: true,
            refreshing: false,
            countingList: [
            ],
            allCountingList: []
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `sysuser/workers`, `screenHeight`, `operation_ward_auth`, `active_hospital_ward`])
    },
    created() {
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            this.getCountInfoBySurgeryId()
        })
    },
    mounted() { },
    beforeRouteLeave(to, from, next) {
        sessionStorage.setItem(`surgeryId`, this.surgeryId)
        sessionStorage.setItem(`surgeryInfo`, JSON.stringify(this.surgeryInfo))
        sessionStorage.setItem(`prevPath`, this.prevPath)
        next()
    },
    methods: {
        gotoCountingItem(item) {
            let countStage = _.orderBy(item.count_stage, `display_order`, `asc`)
            if (item.enum_count_type == 2) {
                this.$router.push({ name: `CountInstrument`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, countStage: countStage, prevPath: this.prevPath } }).catch(err => err)
            } else {
                this.$router.push({ name: `CountSupply`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, countStage: countStage, prevPath: this.prevPath } }).catch(err => err)
            }
        },
        createCountingFlow() {
            this.$router.push({ name: `CountingSelect`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, qxvalue: this.qxvalue, hcvalue: this.hcvalue, prevPath: this.prevPath } }).catch(err => err)
        },
        printFlow() {
            let docid = this.$root.DOCUMENT.QDD052
            if (!docid) {
                return
            }
            if (!this.countingList || this.countingList.length == 0) {
                this.$message.error(`没有清点记录需要打印`)
                return
            }
            let params = {
                docid: this.$root.DOCUMENT.QDD052,
                id1: this.surgeryId,
                objId: this.countingList[0].group_name
            }
            axios.get(`${this.$root.DOCSERVICE_BASE}/doc3.ashx/fill`, {
                params: Object.assign({
                    from: `202005100000`,
                    to: `202005100000`,
                    id3: 1
                }, params)
            }).then((res) => {
                console.log(`res`, res)
                if (res.Status == `SUCCESS` && res.TargetUrl) {
                    this.downloadPDF(res.FileName, res.TargetUrl)
                }
            }).catch(e => console.log(e))
        },
        downloadPDF(fileName, fileUrl) {
            axios.get(fileUrl + `&type=base64&r=` + Math.random()).then(data => {
                let base64String = `data:application/pdf;base64,${data}`
                // 将Base64字符串转换为Blob对象
                const blob = this.base64ToBlob(base64String)

                // 创建一个指向Blob对象的URL
                const url = URL.createObjectURL(blob)
                const link = document.createElement(`a`)
                link.href = url
                link.download = fileName // 设置下载的文件名
                document.body.appendChild(link)
                link.click() // 模拟点击下载
                document.body.removeChild(link) // 下载完成后移除元素
                window.URL.revokeObjectURL(link.href) // 释放掉blob对象占用的内存
            }).catch(e => console.log(e))
        },
        base64ToBlob(base64) {
            const parts = base64.split(`;base64,`)
            const contentType = parts[0].split(`:`)[1]
            const raw = window.atob(parts[1])
            const rawLength = raw.length
            const uInt8Array = new Uint8Array(rawLength)

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i)
            }

            return new Blob([uInt8Array], { type: contentType })
        },
        back() {
            if (!this.prevPath) {
                this.$router.push({ path: `/t_transferList` }).catch(err => err)
            } else {
                this.$router.push({ name: `SurgeryDetail`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo } }).catch(err => err)
            }
        },
        getCountInfoBySurgeryId() {
            if (!this.surgeryId) { return }
            let req = this.myaxios.get(`/api/Nursing/CountingFlow/GetFlow?surgeryId=${this.surgeryId}`)
            req.then(data => {
                this.countingList = data
                var hcitem = data && _.find(data, { enum_count_type: 1 })
                this.hcvalue = hcitem && hcitem.sys_counting_config_id
                var qxitem = data && _.find(data, { enum_count_type: 2 })
                this.qxvalue = qxitem && qxitem.sys_counting_config_id
                console.log(this.countingList)
            }).catch(e => console.log(e))
        },
        onLoad() { },
        onRefresh() {
            let that = this
            that.refreshing = false
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            // if (newUrl.path == `/t_countinglist`) {
            //     this.surgeryId = this.$route.query.surgeryId
            //     this.surgeryInfo = this.$route.params.surgeryInfo
            //     this.getCountInfoBySurgeryId()
            // }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar{
    background-color: #04A891;
    border:unset !important;
    /deep/ .van-icon{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__text{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__title{
        color:#ffffff !important;
    }
}
.van-hairline--bottom::after{
    border-bottom-width:0px !important;
}
.header {
    color:#ffffff !important;
    background: #04A891 !important;
    font-size: 14px;
    text-align: left;
    .patient {
        line-height: 23px;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 46px;
        .name{
            padding:0 20px;
            font-size: 17px;
        }
    }
    .surgery {
        border-top: 1px dashed #ffffff;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-wrap: wrap;
        div {
            width: 50%;
            height:30px;
            line-height:30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            padding: 0 16px;
        }
        .time{
            flex-basis:100% !important;
        }
    }
    .more{
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        justify-content: space-between;
        margin: 0 16px;
        padding-bottom: 10px;
        .moredevice{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            max-width: 80%;
        }
        }
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width:100%;
    .btnTrans {
        flex:1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}

.scrollContent{
    overflow-y: auto;
    overflow-x: hidden;
}
.content{
        display:flex;
        font-size:22px;
        text-align:left;
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/CountingList.vue